module.exports = __webpack_public_path__ + "static/media/welcome2.46211fba.webp";